import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer, Slide } from "react-toastify";
import CssBaseline from "@mui/material/CssBaseline";

import "./App.css";

import { UserProvider } from "./AuthContext";
import AppTheme from "./shared-theme/AppTheme";
import ProtectedRoute from "./ProtectedRoute";

import Dashboard from "./pages/dashboard/Dashboard";
import SignIn from "./pages/login/Login";
import SignUp from "./pages/sign-up/SignUp";
import Payment from "./pages/payment/payments";
import NotFound from "./pages/404/NotFound";
import Landing from "./pages/landing/Landing";
import Generate from "./pages/generate/Generate";
import Profile from "./pages/profile/Profile";
import ResetPassword from "./pages/login/ResetPassword";
import usePageTracking from "./usePageTracking";

function App() {
  usePageTracking();

  return (
    <AppTheme>
    <CssBaseline enableColorScheme />
    <GoogleOAuthProvider clientId="546803829941-irksnlgq0o9auv9g7e7j649fjgmairqm.apps.googleusercontent.com">
      <UserProvider>
          <Routes>
              <Route exact path='/reset' element={<ResetPassword/>} />
              <Route path="/404" element={<NotFound />} />
              <Route exact path="/" element={<Landing />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />}>
                  <Route path="generate" element={<Generate />} />
                  <Route path="settings" element={<Profile />} />
                  <Route path="billing" element={<Navigate to="/dashboard/settings" replace />} />
                  <Route path="pricing" element={<Navigate to="/dashboard/settings" replace />} />
                </Route>
              </Route>
              <Route exact path='/signup' element={<SignUp/>} />
              <Route exact path='/login' element={<SignIn/>} />
              <Route exact path='/payment' element={<Payment/>}/>
              <Route path="*" element={<NotFound />} />
          </Routes>
      </UserProvider>
      <ToastContainer 
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        transition={Slide}
      />
    </GoogleOAuthProvider>
    </AppTheme>
  );
}

export default App;